import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ChevronRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-32 pb-20 bg-gradient-to-b from-slate-50 to-white overflow-hidden" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="text-center max-w-4xl mx-auto" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-185">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 text-blue-700 text-sm font-semibold mb-6 border border-blue-100" data-id="element-186">
              <CalendarIcon className="w-4 h-4" data-id="element-187" />
              Anticipated Launch: August 1, 2026
            </span>
            <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 tracking-tight mb-6" data-id="element-188">
              A Smarter Cloud Desk for <br data-id="element-189" />
              <span className="text-blue-600" data-id="element-190">Small Business</span> Is Coming
              Soon
            </h1>
            <p className="text-lg md:text-xl text-slate-600 mb-10 leading-relaxed" data-id="element-191">
              BizCloudDesk will provide professional cloud, CRM, VoIP, website,
              automation, and digital business solutions designed for small
              businesses, solopreneurs, consultants, and service-based
              professionals.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-192">
            <button onClick={() => scrollToSection('early-access')} className="w-full sm:w-auto px-8 py-4 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-2 group" data-id="element-193">
              Request Early Access
              <ChevronRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-194" />
            </button>
            <button onClick={() => scrollToSection('early-access')} className="w-full sm:w-auto px-8 py-4 bg-white text-slate-900 font-bold rounded-xl border-2 border-slate-200 hover:border-blue-600 hover:text-blue-600 transition-all" data-id="element-195">
              Notify Me When Live
            </button>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-sm text-slate-500 max-w-2xl mx-auto italic" data-id="element-196">
            Be among the first to receive launch updates, service previews, and
            early onboarding opportunities before the anticipated August 1, 2026
            launch.
          </motion.p>
        </div>
      </div>
    </section>;
}